import { createContext, useContext, useEffect, useState } from "react";
import { getAdminSession, watchAdminSession, loginAdmin, logoutAdmin } from "@/lib/backend";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=admin

  useEffect(() => {
    let active = true;
    let unsubscribe = () => {};
    getAdminSession().then((admin) => { if (active) setUser(admin); }).catch(() => { if (active) setUser(false); });
    watchAdminSession((admin) => { if (active) setUser(admin); }).then((stop) => {
      if (active) unsubscribe = stop; else stop();
    }).catch(() => {});
    return () => { active = false; unsubscribe(); };
  }, []);

  const login = async (email, password) => {
    const admin = await loginAdmin(email, password);
    setUser(admin);
    return admin;
  };

  const logout = async () => {
    await logoutAdmin();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
